import { apiMethod } from '../../../shared';
import { APINames } from 'src/shared';
import { isFunction, reportErrorLog } from '../../utils';
const apiName = 'onKeyboardHeightChange';

// 监听键盘高度变化事件
export function onKeyboardHeightChange(listener: Function) {
  if (!isFunction(listener)) {
    reportErrorLog(apiName, 'callback is not a function');
    return;
  }
  apiMethod.on(APINames.Native.ON_KEYBOARD_HEIGHT_CHANGE, listener);
}
